import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  registerRequest: ['email', 'childName', 'parentName', 'relation'],
  registerSuccess: ['status'],
  registerFailure: null,
  resetData: null
});

export const RegisterTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  email: null,
  childName: null,
  parentName: null,
  relation: null,
  fetching: null,
  status: null,
  error: null
});

/* ------------- Selectors ------------- */

export const RegisterSelectors = {
  getData: (state: any) => state.register.data,
  isFetching: (state: any) => state.register.fetching,
  isSuccess: (state: any) => state.register.success,
  hasError: (state: any) => state.register.error,
  getStatus: (state: any) => state.register.status,
};

/* ------------- Reducers ------------- */

// request the data from an api
export const request = (state: any, { email, childName, parentName, relation }: any) => {
  const updateData = {
    email,
    childName,
    parentName,
    relation,
    fetching: true,
    success: false,
    error: false,
    status: null
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

// successful api lookup
export const success = (state: any, action: any) => {
  const { status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    status
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

// Something went wrong somewhere.
export const failure = (state: any, action: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    status: null
  };
  
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const resetData = (state: any) => {
  return state.merge ? state.merge(INITIAL_STATE) : INITIAL_STATE;
};
/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.REGISTER_REQUEST]: request,
  [Types.REGISTER_SUCCESS]: success,
  [Types.REGISTER_FAILURE]: failure,
  [Types.RESET_DATA]: resetData
});
